import React from "react";
// import ReactGA from "react-ga";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import Home from "./pages/Home/index";
import Spot from "./pages/Spot/index";
import Settings from "./pages/Settings/index";

const GlobalStyle = createGlobalStyle`
  ${reset}
  body {
    font-family: "Open Sans";
    font-weight: 300;
    color: #383838;
  }

  * {
    box-sizing: border-box;
  }
`;

function App() {
  // ReactGA.initialize("UA-150125467-2");
  // ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <Router>
      <GlobalStyle />
      <Route exact path="/" component={Home} />
      <Route path="/settings" component={Settings} />
      <Route path="/spot/:spotName" component={Spot} />
    </Router>
  );
}

export default App;
